import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

import type { Announcement } from '@/types/announcement';
import { config } from '@/config';
import { useMounted } from '@/hooks/use-mounted';

interface AnnouncementResponse {
  error: any;
  loading: boolean;
  handleAnnouncementsGet: () => void;
  announcement: Announcement;
}

export const useAnnouncement = (announcementId: string): AnnouncementResponse => {
  const [announcement, setAnnouncement] = useState<Announcement>({} as Announcement);
  const [loading, setLoading] = useState(true);
  const isMounted = useMounted();
  const [error, setError] = useState<string | null>(null);
  console.log(announcementId);
  const handleAnnouncementsGet = useCallback(async () => {
    try {
      const response = await axios.get(`${config.site.api}/api/v1/announcements/${announcementId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          Accept: 'application/json',
        },
      });
      const data = response.data;

      if (isMounted()) {
        setAnnouncement(data?.data ?? ({} as Announcement));
        setLoading(false);
      }
    } catch (err: any) {
      if (isMounted()) {
        if (err.response?.status === 404) {
          setError('Announcement not found');
        } else {
          setError('Failed to load announcement');
        }
        setLoading(false);
      }
      console.error(err);
    }
  }, [isMounted]);

  useEffect(() => {
    handleAnnouncementsGet();
  }, [handleAnnouncementsGet]);

  return { announcement, loading, error, handleAnnouncementsGet };
};
